import { colorsLight } from '../colors.light';

export const checkboxLight = {
  display: 'flex',
  width: 20,
  height: 20,
  borderStyle: 'solid',
  borderWidth: 1,
  borderRadius: 5,
  transition: 'all 150ms',
  borderColor: 'primary/text',
  textStyle: {
    paddingLeft: 'xs',
    color: 'grey/dark',
  },
  states: {
    '&:hover': {
      boxShadow: `0 0 0 3px ${colorsLight.primary}`,
    },
  },
  variants: {
    checked: {
      backgroundColor: colorsLight.primary,
      borderColor: colorsLight.primary,
      states: {
        '&:hover': {
          boxShadow: `0 0 0 3px ${colorsLight['grey/dark']}`,
        },
      },
    },
    disabled: {
      pointerEvents: 'none',
      opacity: 0.4,
      states: {
        '&:hover': {
          boxShadow: 'none !important',
        },
      },
    },
  },
};
